import type { DragEvent } from 'react'
import { useReactFlow } from '@xyflow/react'
import { NODE_DEFAULTS, useFlowStore } from '../store/flowStore'
import type { NodeKind } from '../types'

const PALETTE: { kind: NodeKind; title: string }[] = [
  { kind: 'startEnd', title: 'Início / Fim' },
  { kind: 'process', title: 'Processo' },
  { kind: 'decision', title: 'Decisão' },
  { kind: 'inputOutput', title: 'Entrada / Saída' },
  { kind: 'annotation', title: 'Anotação' },
  { kind: 'group', title: 'Grupo' },
]

export function FlowPalette() {
  const addNode = useFlowStore((s) => s.addNode)
  const readOnly = useFlowStore((s) => s.readOnly)
  const presentationMode = useFlowStore((s) => s.presentationMode)
  const { screenToFlowPosition } = useReactFlow()

  if (readOnly || presentationMode) return null

  const onDragStart = (event: DragEvent, kind: NodeKind) => {
    event.dataTransfer.setData('application/reactflow', kind)
    event.dataTransfer.effectAllowed = 'move'
  }

  const addAtCenter = (kind: NodeKind) => {
    const defaults = NODE_DEFAULTS[kind]
    const center = screenToFlowPosition({
      x: window.innerWidth / 2,
      y: window.innerHeight / 2,
    })
    addNode(kind, {
      x: center.x - defaults.width / 2,
      y: center.y - defaults.height / 2,
    })
  }

  return (
    <section className="sidebar-section sidebar-palette">
      <h2 className="sidebar-title">Nós</h2>
      <div className="palette">
        {PALETTE.map(({ kind, title }) => (
          <button
            key={kind}
            type="button"
            className={`palette-item palette-${kind}`}
            draggable
            onDragStart={(e) => onDragStart(e, kind)}
            onDoubleClick={() => addAtCenter(kind)}
            title={`${title} — arraste ou dê duplo clique`}
          >
            <span
              className={`palette-shape shape-${kind}`}
              style={{ ['--shape-color' as string]: NODE_DEFAULTS[kind].color }}
            />
            <span className="palette-text">{title}</span>
          </button>
        ))}
      </div>
    </section>
  )
}
